// libs
import * as popper from '@popperjs/core'
import * as bootstrap from 'bootstrap';

// components
import initHeader from './components/header';
import initAnims from './components/anims';
import initGallery from './components/gallery';
import initTimeline from './components/timeline';
import initHome from './components/home';
import initItemCards from './components/item-cards';
import initPlayer from './components/player';
import initPeople from './components/people';
import initNews from './components/news';

// Import styles
import '../scss/styles.scss';


initHeader();

if(document.querySelector('.gallery')) initGallery();
if(document.querySelector('.mod-timeline')) initTimeline();
if(document.querySelector('.home__hero')) initHome();
if(document.querySelector('.item-cards')) initItemCards();
if(document.querySelector('.people')) initPeople();

initPlayer();
initNews();

window.isInViewport = function (elem) {
	var distance = elem.getBoundingClientRect();
	return (
		distance.top >= 0 &&
		distance.left >= 0 &&
		distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		distance.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

window.isInViewportTop = function (elem) {
	var distance = elem.getBoundingClientRect();
	return (
    distance.top >= 0 &&
    distance.bottom <= ((window.innerHeight || html.clientHeight) + 400)
  );
};

// animations
initAnims();



